import en from "./localeEn";
import es from "./localeEs";
import pt from "./localePt";
var locales = {
  es: es,
  pt: pt,
  en: en
};
export default locales;